var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlusBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3333 8.33333H9.66667V1.66667C9.66667 1.48986 9.59643 1.32029 9.47141 1.19526C9.34638 1.07024 9.17681 1 9 1V1C8.82319 1 8.65362 1.07024 8.5286 1.19526C8.40357 1.32029 8.33333 1.48986 8.33333 1.66667V8.33333H1.66667C1.48986 8.33333 1.32029 8.40357 1.19526 8.5286C1.07024 8.65362 1 8.82319 1 9H1C1 9.17681 1.07024 9.34638 1.19526 9.47141C1.32029 9.59643 1.48986 9.66667 1.66667 9.66667H8.33333V16.3333C8.33333 16.5101 8.40357 16.6797 8.5286 16.8047C8.65362 16.9298 8.82319 17 9 17C9.17681 17 9.34638 16.9298 9.47141 16.8047C9.59643 16.6797 9.66667 16.5101 9.66667 16.3333V9.66667H16.3333C16.5101 9.66667 16.6797 9.59643 16.8047 9.47141C16.9298 9.34638 17 9.17681 17 9C17 8.82319 16.9298 8.65362 16.8047 8.5286C16.6797 8.40357 16.5101 8.33333 16.3333 8.33333Z",
    fill: "#0095FF",
    stroke: "#0095FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusBlue);
export default __webpack_public_path__ + "static/media/iconPlusBlue.fe28bea4a6f45ed9a51aa903886179ab.svg";
export { ForwardRef as ReactComponent };